
import { cn } from "@/lib/utils";
import { Users, Home, Map, MapPin } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";

const NavBar = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const navItems = [
    { path: "/", icon: Home, label: "Home" },
    { path: "/games", icon: Map, label: "Games" },
    { path: "/courses", icon: MapPin, label: "Courses" },
    { path: "/friends", icon: Users, label: "Friends" }
  ];

  // Check if the app is running as a PWA
  const isPWA = window.matchMedia('(display-mode: standalone)').matches ||
                window.navigator.standalone ||
                document.referrer.includes('android-app://');

  return (
    <div className={cn(
      "fixed bottom-0 left-0 right-0 bg-white border-t border-border flex justify-around items-center px-4 z-10",
      isPWA ? "h-20" : "h-16"
    )}>
      {navItems.map((item) => {
        const isActive = item.path === "/"
          ? pathname === "/"
          : pathname.startsWith(item.path);

        return (
          <div
            key={item.path}
            onClick={() => navigate(item.path)}
            className={cn(
              "flex flex-col items-center justify-center p-2 rounded-md transition-colors cursor-pointer",
              isPWA ? "py-3" : "py-2",
              isActive
                ? "text-forest"
                : "text-muted-foreground hover:text-forest"
            )}
          >
            <item.icon className={isPWA ? "h-6 w-6" : "h-5 w-5"} />
            {isActive && (
              <div className="w-1 h-1 rounded-full bg-gold mt-1" />
            )}
            {!isActive && (
              <span className={cn(
                "mt-1",
                isPWA ? "text-xs" : "text-[11px]"
              )}>{item.label}</span>
            )}
            {isActive && (
              <span className={cn(
                "font-medium",
                isPWA ? "text-xs" : "text-[11px]"
              )}>{item.label}</span>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default NavBar;
